module.exports = __webpack_public_path__ + "img/hr-red-asterisk-00.7a2f44a5.png";